import type { BraceletPatternDto, PatternType } from '@miyuki/types';

import { ValidationError } from '../errors';

import { PATTERN_TYPES } from './pattern.constants';
import { NO_CHANGES, type PatternEdit } from './pattern.entity';

export function assertPatternType(patternType: PatternType): void {
  if (!PATTERN_TYPES.includes(patternType)) {
    throw new ValidationError(`El tejido debe ser uno de: ${PATTERN_TYPES.join(', ')}`, [
      { path: 'patternType', message: `Recibido: ${String(patternType)}` },
    ]);
  }
}

/**
 * Cambia el tejido del diseño.
 *
 * Los dos tejidos leen exactamente la misma cuadrícula: lo único que cambia es
 * dónde se dibuja cada fila. Por eso esta operación no puede perder una
 * mostacilla aunque quisiera — devuelve el mismo patrón con un campo distinto —
 * y por eso no hace falta preguntar nada antes de aplicarla.
 *
 * El parche inverso es un `snapshot`, igual que en `resizeColumns`: un cambio
 * estructural es raro y el snapshot comparte en memoria todas las filas, así
 * que el historial no crece de forma apreciable.
 */
export function setPatternType(pattern: BraceletPatternDto, patternType: PatternType): PatternEdit {
  assertPatternType(patternType);

  if (patternType === pattern.patternType) return { pattern, undo: NO_CHANGES };

  return {
    pattern: { ...pattern, patternType },
    // Cambiar el tejido no agrega ni quita filas: el avance no se mueve (RF-66).
    undo: { kind: 'snapshot', pattern, progressDelta: 0 },
  };
}
